import { VButtonStatus } from "@directives/_forms/v-input/v-input.component";
import { ManualTests } from "@foundation/_services/manual-device-validation-check.service";
import { IUser } from "@interfaces/IUser";
import { IVehicle } from "@interfaces/IVehicle";
import { IAccount } from "@services/account.service";
import { IPeripheral, IUnit } from "@interfaces/IPeripheral";
import { AampSimStatus, Category, DriverIdType, EngineerCommissionStatus, EngineerJobItemStatus, EngineerJobItemType, IAampAlarmType, IgnitionType, NonTestableDevices, TachoType, CommissioningCheckType, ValidationResult, ImportStrategyReference, ImportType, CommissionVisitStatus, CommissionActionType, CommissionWorkflowType } from "./foundation.enums";
import { IEngineerJobBookingMapping } from "./_models/IEngineerJobBookingMapping";
import { ValidationCheck, ValidationCheckType } from "./_services/device-data-validation.service";
import { ProductVendor } from "@app/main/components/videos/enums/CameraProductType";
import { IUserGroup } from "./_models/IUserGroup";
import { ISim, SimType } from "@app/interfaces/ISim";
import { ISerialSearchResponse } from "./_models/ISerialSearchResponse";
import { ISimMapping } from "@app/interfaces/ISimMapping";
import { ErrorType } from "./_enums/ErrorType";

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface IEngineer {
    Id: number;
    UserId: number;
    Name: string;
    Username: string;
    Password: string;
    Mobile: string;
    Status: number;
    GroupId: number;
    Colour: string;
    FitterId: number;
    AdminId?: number;
}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface IEngineerJobBooking {
    Id?: number;
    SiteId?: number;
    JobId?: number;
    StartUtc?: Date;
    EndUtc?: Date;
    Description?: string;
}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface IEngineerJobBookingWithEngineerMappings extends IEngineerJobBooking {
    mappings?: IEngineerJobBookingMapping[];
    assignedEngineers?: IUser[];
    assignedGroupId?: number;
    assignedGroup?: IUserGroup;

}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface IEngineerCommission {
    Id?: number;
    AccountId?: number;
    UserId?: number;
    EngineerUserId?: number;
    // Serial and IMEI of the Tracking Device within a vehicle
    Serial?: string;
    Imei?: string;

    // Use this to store peripherals for commission submission
    //pendingUnitsAndPeripherals?: IUnit[];
    pendingCommissionChanges: ICommissionUnitChanges[];
    Peripherals?: string[];

    // Legacy fields
    CameraId?: string;
    VehicleId?: number;
    DigidlId?: string;
    CanbusId?: string;
    FmiId?: string;
    TdtId?: string;

    Chargeable?: boolean;
    ChargeReason?: string
    Pto?: boolean;
    PtoInputState?: string;
    PtoDescription?: string;
    DriverIdType?: DriverIdType;
    TachoType?: TachoType;
    Cost?: number;
    VoltDropper?: boolean;
    VisitReasonId?: EngineerJobItemType;
    Accelerometer?: boolean;
    Satfix?: number;
    UnitLocation?: string;
    IgnitionState?: IgnitionType;
    LeftOnSite?: boolean;
    AdminId?: number;
    CommissionNumber?: number;
    JobNumber?: number;
    JobItemId?: number;
    Status?: EngineerCommissionStatus;
    Timestamp?: Date;
    EngineerId?: number;
    Model?: string;
    ShortReg?: string;
    Client?: string;
    Odometer?: number;
    VisitReason?: string;
    Comments?: string;
    MessagingId?: string;
    Make?: string;
    Duration?: number;
    Metadata?: ICommissionMetadata;
    // -----

    type?: EngineerJobItemType;
    vehicle?: IVehicle;
    simICCID?: string;
    configId?: number;
    engineerName?: string;
    engineerUser?: IUser;
    internalUser?: IUser;
    accountCompanyName?: string;
    account?: IAccount;
    dirtyCameraId?: string;
    vehicleDetailsConfirmed?: boolean;
    existingHardwareAcquired?: boolean;
    deviceValidationCheckRecordIds?: number[];
}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface ICommissionMetadata {
    Duration?: number;
    DeviceTests?: IAddedDevice[];
    RevisitRequired?: boolean;
    ChargableComments?: string;
    NoFaultFound?: boolean;
}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface IAddedDevice {
    TestResults?: IValidationResultCategory[];
    faultFlagged: boolean;
    faultComments: string;
}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface IEngineerJob {
    Id?: number;
    AccountId?: number;
    Description?: string;
    Status?: EngineerJobStatus;
    CustomerInstruction?: string;
    EngineerInstruction?: string;
    DealId?: number;
    CreatedDate?: Date;

    // ----

    account?: IAccount;
    vehicle?: IVehicle;
    engineer?: IUser;

    jobBooking?: IEngineerJobBookingWithEngineerMappings;
}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface IEngineerJobItem {
    Id?: number;
    JobId?: number;
    Type?: EngineerJobItemType;
    VId?: number;
    PackageId?: number;
    Status?: EngineerJobItemStatus;
    VehicleId?: number;
    Comments?: string;
    DealId?: number;

    // ----

    vehicle?: IVehicle
    account?: IAccount;
    commission?: IEngineerCommission;
    statusIcon?: string;
    statusIconColor?: string;
}

/**
 * @deprecated The interface is for old commissioning should not be removed follwing the rebuild
 */
export enum EngineerJobStatus {
    Open = 0,
    Booked = 1,
    Completed = 2,
    Cancelled = 3,
    OnHold = 4,
    ToRebook = 5,
    Provisional = 6,
}

/**
 * @deprecated The interface is for old commissioning should not be used in the rebuild other than for legacy histories
 */
export interface CommissionTestObject {
    CommissioningCheckType: CommissioningCheckType,
    Category: Category,
    DelegateToUse: IValidationCheck
}

export interface IAampAlarmData extends IAampGpsData {
    Type: IAampAlarmType;
    Content: string;
    CmdType: number;
}

export interface IAampGpsData {
    GpsTime: Date;
    Altitude: number;
    Direction: number;
    GpsLat: number;
    GpsLng: number;
    Speed: number;
    RecordSpeed: number;
    State: number;
    Time: Date;
    TerId: string;
}

export interface IAampCompiledTestObject {
    GpsRecords?: IAampGpsData[];
    AlarmRecords?: IAampAlarmData[];
    FootageRecords?: IDeviceDayCalendar[];
}

export interface IDeviceDayCalendar {
    chn?: number;
    starttime?: Date;
    endtime?: Date;
}

export interface IFtCloudGpsData {
    Serial: string,
    VehicleId, string,
    EventTime: Date,
    Latitude: number,
    Longitude: number,
    Sat: number,
    OdometerKm: number,
    Signal: number
}

export interface IftCloudAlarmData {
    AlarmId?: number,
    AlarmType?: number,
    StartTime?: Date,
    EndTime?: Date
    gpsInfo?: IFtCloudAlarmGpsInfo
}

export interface IFtCloudAlarmGpsInfo {
    Latitude?: number,
    Longitude?: number
}

export interface IftCloudCompiledTestObject {
    GpsRecords?: IFtCloudGpsData[];
    AlarmRecords?: IftCloudAlarmData[];
    FootageRecords?: IFtCloudFootageHistory[];
}

export interface IFtCloudFootageHistory {
    StartTime?: Date;
    EndTime?: Date;
    Channel?: number;
}

export interface IDataCollectionMethod<T> {
    dataCollectionMethod?: () => Promise<T>;
    dataCollectionPromise?: Promise<T>;

    data?: T;
}

export interface ICommissionTestResult {
    testName?: string;
    testInfo?: string;
    resultStatus?: ValidationResult;
}

export interface IValidationResultCategory {
    name?: string;
    checkResults?: ICommissionTestResult[];
    faultFlagged?: boolean;
    faultComments?: string;
}

export interface IValidationCheckCategory<T = any> extends IDataCollectionMethod<T> {
    name: string;
    checks: IValidationCheck<T>[];

    showData?: boolean;

    // ---

    statusIcon?: string;
    statusClass?: string;

    totalChecks?: number;
    completedChecks?: number;
    passingChecks?: number;
    warningChecks?: number;
    failingChecks?: number;
    criticalChecks?: number;

    faultComments?: string;
}

export interface IValidationCheck<T = any> extends IDataCollectionMethod<T>/*, IValidationMethod<T> */ {
    checkDescription: string;
    currentState?: string;
    information?: string;
    className?: string;

    loading?: boolean;

    validationMethod: (data: T) => ValidationResult;
    validationMessage?: string;
    validationResult?: ValidationResult;
    infoMessage?: string;

    createSuccessMessage?: (data: T) => string;
    createInfoMessage?: (data: T) => string;
    createErrorMessage: (data: T) => string;

    criticalCheck?: boolean;
}

export interface IAampSimStorageStatus {
    LastUpdateTimeUtc: Date;
    TotalStorage: number;
    FreeStorage: number;
    IgnitionOn: boolean;
    SimStatus3G: AampSimStatus;
    SimStrength3G: number;
    SimStatus4G: AampSimStatus;
    SimStrength4G: number;
    CurrentlyRecording: boolean;
}

export interface IManualTestValidation {
    name: string;
    assertion: string;
    testConfirmation?: ValidationResult;
    test: ManualTests;
}

export interface IManualValidationCheckCategory {
    name: string;
    checks: IManualTestValidation[];
    section: NonTestableDevices;
    faultComments?: string;
}

export interface IDeviceToAdd {
    serial: string;
    label?: string;

    searchResponse?: ISerialSearchResponse;
    categories?: IValidationCheckCategory[];
    manualCategories?: IManualValidationCheckCategory;

    inputStatus: VButtonStatus;
    buttonStatus: VButtonStatus;

    faultRecorded?: boolean;
    faultComments?: string;

    location?: string;
}

export interface ICommissionUnitChanges {
    Unit: IUnit;
    CommissionResults?: IValidationResults[];
    faultFlagged?: boolean;
    faultComments?: string;

    // ----

    isCamera?: boolean;
}

export interface IUserIdToNameMapping {
    UserId: number,
    Username: string,
    Description: string
}

export interface IValidationResults {
    result: ValidationResult;
    checksRun: ValidationCheck[];
}

export interface IProcessResult {
    IsSuccess?: boolean;
    ExceptionMessage?: string;
    Value?: any;
}

export interface IImportValidationDTO {
    CsvString: string,
    ImportStrategyReference: ImportStrategyReference,
    ProductId?: number,
    SimType?: SimType,
    ProductGroupId?: ProductVendor,
    EngineerJobItemType?: EngineerJobItemType;
    JobId?: number;
    AccountId?: number;
}

export interface ICsvImportValidationResultDTO {
    ImportStrategyReference: ImportStrategyReference,
    ModelsToImportJson?: string;
    ImportValidationErrors: ImportValidationError[],
    ImportType?: ImportType;
    MappingsToCreateJson?: string;
    MappingsToEndJson?: string;
    SimsToCreate?: ISim[];

    // -----------

    peripherals?: IPeripheral[];
    units?: IUnit[];
    engineers?: IUser[];
    jobItems?: IJobItemValidationResultDTO[];
    
    simMappings?: ISimMapping[];
}

export interface ICsvImportCompletionDTO {
    ModelsToCreate?: string;
    ImportStrategyReference?: ImportStrategyReference,
    ProductGroupId?: ProductVendor,
    ResellerId?: number,
    ImportType?: ImportType
    MappingsToCreateJson?: string;
    MappingsToEndJson?: string;
    SimsToCreate?: ISim[];
}

export interface ICsvImportCompletionResultDTO {
    CreatedModels?: string;
    ImportType?: ImportType;
}

export interface ImportValidationError {
    LineNumber?: number,
    Message?: string,
    ErrorType?: ErrorType;
    Metadata?: string
}

export interface IJobItemValidationResultDTO {
    Vehicle?: IVehicle,
    VehicleRequiresCreation?: boolean,
    EngineerJobItem?: IEngineerJobItem
}

export interface SimToSerialMappings {
    Item1?: string,
    Item2?: string
}

export interface CommissionVehicleVisit {
    Id: number;
    Comments: string;
    Status: CommissionVisitStatus;
    EngineerId: number;
    ApproverUserId?: number;
    VehicleId: number;
    AccountId: number;
    Actions: CommissionAction[];
    CreatedTime: Date;
    UpdatedTime: Date;
}

export interface CommissionAction {
    ActionId: string;
    ActionIndex: number;
    VehicleId: number;
    Serial: string;
    ProductGroupId: ProductVendor;
    ActionType: CommissionActionType;
    Notes: string;
    VehicleValidationCheckRecords: VehicleValidationCheckRecord[];
    CommissionWorkflows: ICommissionWorkflow[];
}

export interface VehicleValidationCheckRecord {
    Id: number;
    ValidationCheckType: ValidationCheckType;
    EventTime: Date;
    UserId: number;
    VehicleId: number;
    Serial: string;
    CommissionId?: number;
    CommissionVehicleVisitId?: number;
    CommissionActionId?: string;
    ValidationCheckResultJson: string;
}

export interface ICommissionWorkflow {
    Type: CommissionWorkflowType;
    Metadata: string;
    ProductGroupId: ProductVendor;
}
